import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AgentService } from 'src/app/agent/agent.service';

import { trigger, state, transition, style, animate } from '@angular/animations';
import { Agent } from '../agent.model';
import { FormMessage } from 'src/app/ui-design-library/form-message/form-message.model';

@Component({
  selector: 'fnsr-agent-details',
  standalone: true,
  templateUrl: './agent-details.component.html',
  animations: [
    trigger('visibilityChanged', [
      state('shown', style({ opacity: 1 })),
      state('hidden', style({ opacity: 0, transform: 'translateX(100%)', offset: 1.0 })),
      transition('shown => hidden', animate('600ms')),
      transition('hidden => shown', animate('300ms')),
    ])
  ],
  styleUrls: ['./agent-details.component.scss']
})
export class AgentDetailsComponent implements OnInit {
  form!: FormGroup;
  isLoading = false;
  personEditMode = false;
  personEditButton = 'Bearbeiten';
  formMessage?: FormMessage;

  visiblityState = 'hidden';

  constructor(
    public fb: FormBuilder,
    public route: ActivatedRoute,
    public agentService: AgentService,
  ) {
    this.form = fb.group({
        firstName: ['', [Validators.required]],
        lastName: ['', [Validators.required]],
        gender: [{ 'value': '', disabled: true }],
        genderAccuracy: [{ 'value': '', disabled: true }],
        //   isEmployed: ['', [Validators.required]],
        //   intermediaryNumber: ['', [Validators.required]],
        //   registrationNumber: ['', [Validators.required]],
        //   headerSubtitle: ['', [Validators.required]],
      //   greetingFormal2: ['', [Validators.required]],
      //   greetingInformal2: ['', [Validators.required]],
      //   videoBusinessCardUrl: ['', [Validators.required]],
      //   videoBusinessCardThumbnailUrl: ['', [Validators.required]],
      // profession: fb.group({
        //   isLeader: ['', [Validators.required]],
        //   headerTitle: ['', [Validators.required]],
      //   photoProfileUrl: ['', [Validators.required]],
      //   privacyProtectionUrl: ['', [Validators.required]],
      // }),
      // communication: fb.group({
      //   address: ['', [Validators.required]],
      //   addressGoogleMapsUrl: ['', [Validators.required]],
      //   email: ['', [Validators.required]],
      //   // emailUrl: ['', [Validators.required]],
      //   fax: ['', [Validators.required]],
      //   mobilePhone: ['', [Validators.required]],
      //   mobilePhoneUrl: ['', [Validators.required]],
      //   phone: ['', [Validators.required]],
      //   phoneUrl: ['', [Validators.required]],
      //   website: ['', [Validators.required]],
      //   whatsAppUrl: ['', [Validators.required]],
      // }),
      // socialNetwork: fb.group({
      //   facebook: ['', [Validators.required]],
      //   instagram: ['', [Validators.required]],
      //   linkedin: ['', [Validators.required]],
      //   twitter: ['', [Validators.required]],
      //   xing: ['', [Validators.required]],
      //   youtube: ['', [Validators.required]],
      // }),
      // service: fb.group({
      //   videoConferencingUrl: ['', [Validators.required]],
      //   appointmentSchedulingUrl: ['', [Validators.required]],
      // }),
      // mailConfig: fb.group({
      //   bcc: ['', [Validators.required]],
      //   from: ['', [Validators.required]],
      //   host: ['', [Validators.required]],
      //   port: ['', [Validators.required]],
      //   secure: ['', [Validators.required]],
      //   mailConfigRequireTls: ['', [Validators.required]],
      //   auth: fb.group({
      //      user: [''],
      //      pass: [''],
      //   }),
    })
  }

  ngOnInit() {
    this.route.params.subscribe(param => {
      this.getAgent(param['id']);
    });
  }
  getAgent(id: string): void {
    this.isLoading = true;
    this.agentService.getAgent(id).subscribe(
      result => {
        this.isLoading = false;
        this.form?.patchValue(result);
      },
      err => console.log(err)
    );
  }

  // TODO: Prüfen, ob diese vier Funktionen künftig nützlich sind!
  // get firstName(): any {
  //   return this.form.get('person.firstName');
  // }

  // get person(): any {
  //   return this.form.get('person');
  // }

  onSubmit(agent: Agent) {
    console.log(agent)
    this.tooglePersonEditMode()
  }
    //   console.log(this.firstName.value);  // 'Nancy'
    //   console.log(this.person.value);   // {first: 'Nancy', last: 'Drew'}
    //   console.log(this.form.status);  // VALID

  // setPreset() {
  //   this.person.setValue({ first: 'Bess', last: 'Marvin' });
  // }

  tooglePersonEditMode() {
    // TODO: Revert Changes im Formular einbauen, wenn Abbrechen geklickt wird.
    this.personEditMode = !this.personEditMode
    this.personEditMode ? this.personEditButton = 'Abbrechen' : this.personEditButton = 'Bearbeiten'
  }

  toggle() {
    if (this.visiblityState === 'hidden')
      this.visiblityState = 'shown';
    else
      this.visiblityState = 'hidden';
  }
}
